import Columns from './Columns.component';

export default Columns;
